import supabase from "@shared/api/supabase";
import type { Tables, Database } from "@shared/database.types";

export type Flow = Tables<"flows">;

export async function createFlow(input: {
  workspace_id: string;
  name: string;
  description?: string | null;
  graph?: unknown;
  revision?: number;
}): Promise<Flow> {
  const { data: userData } = await supabase.auth.getUser();
  const userId = userData?.user?.id ?? "system";
  type FlowInsert = Database["public"]["Tables"]["flows"]["Insert"];
  const payload: FlowInsert = {
    workspace_id: input.workspace_id,
    name: input.name.trim(),
    description: input.description ?? null,
    graph: (input.graph ?? {}) as any,
    revision: input.revision ?? 1,
    created_by: userId,
    updated_by: userId,
  } as FlowInsert;

  const { data, error } = await supabase
    .from("flows")
    .insert(payload)
    .select()
    .single();
  if (error) throw error;
  return data!;
}

export async function updateFlow(
  id: string,
  patch: Partial<Pick<Flow, "name" | "description">>
): Promise<Flow> {
  const { data, error } = await supabase
    .from("flows")
    .update({
      ...(patch.name !== undefined ? { name: patch.name.trim() } : {}),
      ...(patch.description !== undefined ? { description: patch.description } : {}),
    })
    .eq("id", id)
    .select()
    .single();
  if (error) throw error;
  return data!;
}

export async function deleteFlow(id: string): Promise<void> {
  const { error } = await supabase.from("flows").delete().eq("id", id);
  if (error) throw error;
}

// If we need soft-delete later:
// export async function archiveFlow(id: string): Promise<Flow> {
//   const { data, error } = await supabase.from("flows").update({ is_archived: true }).eq("id", id).select().single();
//   if (error) throw error;
//   return data!;
// }
